import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('website_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      setEmail('');
      return;
    }
    if (!email.trim()) {
      setErrorMsg('请输入您的邮箱地址');
      setStatus('error');
      return;
    }
    setStatus('loading');
    setErrorMsg('');
    try {
      const formData = new FormData(form);
      const res = await fetch('https://readdy.ai/api/form/d9oo5igsenbniolesim0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后再试';
        setErrorMsg(msg);
        setStatus('error');
      }
    } catch {
      setErrorMsg('网络错误，请稍后再试');
      setStatus('error');
    }
  };

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-900">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50">
          订阅更新通知
        </h2>
        <p className="text-sm text-background-400 mt-2 mb-6">
          订阅<strong className="text-background-200">耽美漫画网</strong>更新通知，第一时间获取最新<strong className="text-background-200">免费耽美漫画</strong>上架信息
        </p>

        {status === 'success' ? (
          <div className="flex items-center justify-center gap-2 text-accent-400">
            <i className="ri-checkbox-circle-line text-lg"></i>
            <span className="text-sm">订阅成功！感谢您的关注</span>
          </div>
        ) : (
          <form
            data-readdy-form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
          >
            <div className="spam-trap">
              <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
            </div>
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="请输入您的邮箱"
              className="flex-1 w-full px-4 py-2.5 text-sm bg-background-800 border border-background-700 rounded-full text-background-100 placeholder-background-500 focus:outline-none focus:border-primary-400 transition-all duration-200"
              required
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="w-full sm:w-auto px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 disabled:opacity-50 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              {status === 'loading' ? '订阅中...' : '立即订阅'}
            </button>
          </form>
        )}

        {status === 'error' && errorMsg && (
          <p className="text-xs text-red-400 mt-3">{errorMsg}</p>
        )}
      </div>
    </section>
  );
}